import { apiFetchRaw } from '@/lib/apiFetch';

export type Me = {
  id: number;
  name: string;
  email: string;
  role: 'admin' | 'lead' | 'production' | 'unknown';
  weekly_pole_goal?: number | null;
  avatar_url?: string | null;
};

// SEC.2 T.3: auth-path debug logs gated behind VITE_DEBUG_LOGS so production
// DevTools observers don't see token-presence diagnostics.
const DEBUG = import.meta.env?.VITE_DEBUG_LOGS === '1';
const dlog = (...args: unknown[]) => { if (DEBUG) console.log(...args); };

// Import getIdToken from AuthProvider context dynamically
let _getIdToken: (() => Promise<string | undefined>) | null = null;

export function setAuthTokenGetter(getter: () => Promise<string | undefined>) {
  _getIdToken = getter;
}

export async function fetchMe(): Promise<Me> {
  // Make API request with Authorization header if token getter available
  const headers: HeadersInit = {};

  if (_getIdToken) {
    try {
      const token = await _getIdToken();
      dlog('[fetchMe] Got token:', token ? 'yes' : 'no');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        headers['X-Firebase-Auth'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('[fetchMe] Failed to get token:', error);
    }
  } else {
    dlog('[fetchMe] No token getter available');
  }

  const r = await apiFetchRaw(`/me`, { headers });
  if (!r.ok) throw new Error('me failed');
  return r.json();
}


